﻿import * as $modal from './_modal'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
    textName: string
}

var options: IInitOptions

export function init($options: IInitOptions): void {
    options = $options

    $('.' + options.pageName + ' .bcfla-box img').click(function () {
        $modal.load('/Default/DemoMovieDetails', { movie: $(this).attr('data-movie') }, true, true, false)
    })
}
